function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.5,
  cy: 8.5,
  r: 8.15,
  fill: "#4290F3",
  fillOpacity: 0.1,
  stroke: "#4290F3",
  strokeWidth: 0.7
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.24805 11.9321L9.24805 4.61368C9.24805 4.32498 9.01401 4.09094 8.72531 4.09094C8.4366 4.09094 8.20257 4.32498 8.20257 4.61368L8.20257 11.9321C8.20257 12.2208 8.4366 12.4548 8.72531 12.4548C9.01401 12.4548 9.24805 12.2208 9.24805 11.9321Z",
  fill: "#4290F3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.06709 8.79565L12.3855 8.79565C12.6742 8.79565 12.9082 8.56162 12.9082 8.27291C12.9082 7.98421 12.6742 7.75017 12.3855 7.75017L5.06709 7.75017C4.77839 7.75017 4.54435 7.98421 4.54435 8.27291C4.54435 8.56162 4.77839 8.79565 5.06709 8.79565Z",
  fill: "#4290F3"
});

function SvgPlusRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusRound);
export default __webpack_public_path__ + "static/media/plus-round.b0bbad1d.svg";
export { ForwardRef as ReactComponent };